import React from "react";
import { useSelector } from "react-redux";

import { i18, trb } from "@utilities";
import {
  InputFormField,
  SelectFormField,
  DateFormField
} from "@components/FormField/HookFormFields";
import { selectAvailableCountryOptions, selectDocTypeOptions } from "@redux";
import { HalfWidthInputWrapper } from "@components";

export const ClientRepDocs = ({ control }) => {
  const availableCountries = useSelector(selectAvailableCountryOptions);
  const availableDocTypes = useSelector(selectDocTypeOptions);

  return (
    <>
      <HalfWidthInputWrapper>
        <SelectFormField
          control={control}
          name="clientRep.0.data.clientRepIdDocType"
          title={trb(i18.Labels.ClientRepIdDocType)}
          options={availableDocTypes}
          optionsLabel="label"
          optionsValue="value"
          isSearchable
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <SelectFormField
          control={control}
          name="clientRep.0.data.clientRepDocCountry"
          title={trb(i18.Labels.ClientRepDocCountry)}
          options={availableCountries}
          optionsLabel="label"
          optionsValue="value"
          isSearchable
          defaultValue="LT"
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <InputFormField
          control={control}
          name="clientRep.0.data.clientRepDocIssuePlace"
          title={trb(i18.Labels.ClientRepDocIssuePlace)}
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <DateFormField
          control={control}
          name="clientRep.0.data.clientRepDocIssueDate"
          title={trb(i18.Labels.ClientRepDocIssueDate)}
          maxDate={new Date()}
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <InputFormField
          control={control}
          name="clientRep.0.data.clientRepDocNo"
          title={trb(i18.Labels.ClientRepDocNo)}
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <DateFormField
          control={control}
          name="clientRep.0.data.clientRepDocValidDate"
          title={trb(i18.Labels.ClientRepDocValidDate)}
          minDate={new Date()}
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <DateFormField
          control={control}
          name="clientRep.0.data.clientRepMandatValidDate"
          title={trb(i18.Labels.ClientRepMandatValidDate)}
          minDate={new Date()}
        />
      </HalfWidthInputWrapper>
    </>
  );
};
